import React from 'react';
import { Box, Button, ButtonProps, Typography } from '@drone-js/core';
import { getImageUrl } from 'core/utils/activityUrlGenerator';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

interface Props {
    errorTitleText: string;
    errorDescriptionText?: string;
    buttonText: string;
    buttonHierarchy?: ButtonProps['hierarchy'];
    onClick: () => void;
    assetName: string;
    assetWidth: string;
}

const ErrorContent: React.FC<Props> = React.memo((props) => {
    return (
        <div data-testid="error-contain-container">
            <Box mb="32" display="flex" justifyContent="center">
                <ActivityImage
                    data-testid="activities-error-image"
                    alt={props.errorTitleText}
                    src={getImageUrl(props.assetName)}
                    width={props.assetWidth}
                    loading="immediate"
                    responsive="original"
                />
            </Box>
            <Typography variant="heading-xl" data-testid="activities-error-title-message" textAlign="center">
                {props.errorTitleText}
            </Typography>
            {props.errorDescriptionText && (
                <Typography mt="4" variant="body-default" data-testid="activities-error-description-message" textAlign="center" textColor="base.subtle">
                    {props.errorDescriptionText}
                </Typography>
            )}
            <Box mb="32" display="flex" justifyContent="center">
                <Button
                    variant="label"
                    hierarchy={props.buttonHierarchy}
                    data-testid="activities-page-content-error-button"
                    data-element-name="activities-page-content-error-button"
                    onClick={props.onClick}
                    mt="16"
                    label={props.buttonText}
                />
            </Box>
        </div>
    );
});

ErrorContent.displayName = 'ErrorContent';
export default ErrorContent;
